import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Keep a console trace for debugging; avoids full white page in production.
    // eslint-disable-next-line no-console
    console.error("❌ UI crashed:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
          <h2 style={{ marginTop: 0 }}>Something went wrong</h2>
          <p style={{ color: "#888" }}>
            This usually happens after a disconnect/session expiry or a UI runtime error.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "10px 14px",
              borderRadius: 8,
              border: "1px solid #444",
              background: "#111827",
              color: "white",
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


